/* global axios */

import ApiClient from './ApiClient';

class InternalChatAPI extends ApiClient {
  constructor() {
    super('internal_chat/threads', { accountScoped: true });
  }

  createThread(data) {
    return axios.post(this.url, { internal_chat_thread: data });
  }

  markRead(threadId) {
    return axios.post(`${this.url}/${threadId}/read`);
  }

  deleteThread(threadId) {
    return axios.delete(`${this.url}/${threadId}`);
  }

  getMessages(threadId, beforeId) {
    const params = beforeId ? { before_id: beforeId } : {};
    return axios.get(`${this.url}/${threadId}/messages`, { params });
  }

  createMessage(threadId, { content, files = [], replyToMessageId = null }) {
    if (files.length) {
      const formData = new FormData();
      formData.append('internal_chat_message[content]', content);
      if (replyToMessageId) {
        formData.append(
          'internal_chat_message[reply_to_message_id]',
          replyToMessageId
        );
      }
      files.forEach(file => {
        formData.append('internal_chat_message[files][]', file);
      });

      return axios.post(`${this.url}/${threadId}/messages`, formData);
    }

    return axios.post(`${this.url}/${threadId}/messages`, {
      internal_chat_message: {
        content,
        reply_to_message_id: replyToMessageId,
      },
    });
  }

  updateMessage(threadId, messageId, content) {
    return axios.patch(`${this.url}/${threadId}/messages/${messageId}`, {
      internal_chat_message: { content },
    });
  }
}

export default new InternalChatAPI();
